module.exports = __webpack_public_path__ + "static/media/example2.8273421d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/example2.png
// module id = 308
// module chunks = 0